module.exports = __webpack_public_path__ + "static/content-blogs-82ca423d6549e8944015363763cbea26.svg";